module.exports = __webpack_public_path__ + "static/media/device2.8ba103b0.png";